export const contactDetailsEditableOptions = {
    "- None -": "",
    Yes: true,
    No: false,
}
